const { createContext, useContext, useState, useMemo, useEffect } = require('react')

const AppContext = createContext()

export function AppProvider({ children }) {
  const [alert, setAlert] = useState(undefined)
  const [authUser, setAuthUser] = useState({ isLoggedIn: false }) // TODO: Actual login
  const { authState, oktaAuth } = useState({}) // TODO:  useOktaAuth()

  useEffect(() => {
    if (authState === null || authState?.isAuthenticated === false) {
      setAuthUser(undefined)
    } else {
      // OKTA Login
      // oktaAuth
      //   .getUser()
      //   .then((info) => {
      //     setAuthUser({
      //       ...info,
      //       accessToken: `Bearer ${authState?.accessToken?.accessToken || ''}`,
      //     });
      //   })
      //   .catch((err) => {
      //     console.error(err);
      //   });
    }
  }, [authState, oktaAuth, setAuthUser])

  const appProviderValue = useMemo(
    () => ({
      alert,
      authUser,
      setAlert,
      setAuthUser,
    }),
    [alert, setAlert, authUser]
  )

  return <AppContext.Provider value={appProviderValue}>{children}</AppContext.Provider>
}

export const useApp = () => useContext(AppContext)
